import { toPrismicLang } from '../../helpers/i18n';
import { handleError } from '../errors';

import { getByIDs } from '../../api/prismic';

export const LOAD_DOCUMENTS_BY_IDS_REQUEST = 'LOAD_DOCUMENTS_BY_IDS_REQUEST';
export const LOAD_DOCUMENTS_BY_IDS_SUCCESS = 'LOAD_DOCUMENTS_BY_IDS_SUCCESS';
export const LOAD_DOCUMENTS_BY_IDS_FAILURE = 'LOAD_DOCUMENTS_BY_IDS_FAILURE';

export const loadDocumentsByIdsRequest = (lang, ids) => ({
  type: LOAD_DOCUMENTS_BY_IDS_REQUEST,
  lang,
  ids,
});

export const loadDocumentsByIdsSuccess = (lang, ids, documents) => ({
  type: LOAD_DOCUMENTS_BY_IDS_SUCCESS,
  payload: documents,
  lang,
  ids,
});

export const loadDocumentsByIdsFailure = (lang, ids, error) => ({
  type: LOAD_DOCUMENTS_BY_IDS_FAILURE,
  payload: error,
  lang,
  ids,
});

export const getDocumentsByIds = (ids) => async (dispatch, getState) => {
  const { locale } = getState();
  const lang = toPrismicLang(locale);

  try {
    dispatch(loadDocumentsByIdsRequest(locale, ids));
    const result = await getByIDs(ids, { lang });
    dispatch(loadDocumentsByIdsSuccess(locale, ids, result.results));
  } catch (error) {
    const fallback = loadDocumentsByIdsFailure(locale, ids, error);
    handleError(dispatch, error, fallback);
  }
};
